import { enums } from "@shared/constants";
import { PublicInternalAnalyticsTrackingSerializerWithLabelString } from "@shared/modules/analytics/types";
import { IInteractionDataBuilder } from "./IInteractionDataBuilder";

/**
 * Builder for button click events.
 */
export class ButtonClickDataBuilder implements IInteractionDataBuilder {
  private data?: Omit<
    PublicInternalAnalyticsTrackingSerializerWithLabelString,
    "interaction_type"
  >;

  constructor(
    data?: Omit<
      PublicInternalAnalyticsTrackingSerializerWithLabelString,
      "interaction_type"
    >
  ) {
    this.data = data;
  }

  build(): PublicInternalAnalyticsTrackingSerializerWithLabelString {
    return {
      ...this.data,
      interaction_type: enums.INTERACTION_TYPE_MAP.BUTTON_CLICK.id,
    };
  }
}
